import { useEffect, useRef } from 'react';

import { AskMode, QuestionAnswerBlockStatus } from '@/entities/ask-syncly/constants';
import type { AskSynclySession, CurrentAnswerBlock } from '@/entities/ask-syncly/types';
import { ToggleStage } from '@/shared/components/stage/toggle-stage';
import { cn } from '@/shared/utils/cn';
import { scrollTo } from '@/shared/utils/scroll-to';
import { ComponentMapper } from './deep-research/component-mapper';
import { QuestionBox } from './deep-research/question-box';
import { Reasoning } from './deep-research/reasoning-display';

interface ChatDisplayProps {
  className?: string;
  session?: AskSynclySession;
  currentAnswerBlock?: Partial<CurrentAnswerBlock> | null;
  isChatSessionLoading?: boolean;
  mode: AskMode;
}

export function ChatDisplay({ className, session, currentAnswerBlock, mode }: ChatDisplayProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const currentBlockRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (currentBlockRef.current && scrollContainerRef.current) {
      scrollTo(currentBlockRef.current, scrollContainerRef.current, 12);
    }
  }, [currentAnswerBlock]);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
      });
    }
  }, []);

  if (!session) return null;

  return (
    <div
      ref={scrollContainerRef}
      className={cn('bg-muted flex w-full flex-col gap-6 p-6', className)}
      style={{ scrollbarGutter: 'stable' }}
    >
      {/* 기존 질문/답변들을 그 다음에 표시 */}
      {session?.blocks?.map((block) => (
        <div key={block.id} className="flex flex-col gap-4">
          <div className="self-end">
            <QuestionBox question={block.question} mode={mode} />
          </div>
          <Reasoning reasons={block.reasons} status={QuestionAnswerBlockStatus.COMPLETED} />
          {block.answers.map((answer, index) => (
            <ComponentMapper
              key={`${answer.type}-${index}`}
              session_id={session.id}
              answer={answer}
              block_id={block.id}
            />
          ))}
        </div>
      ))}
      {/* 현재 진행 중인 질문/답변을 먼저 표시 (상단) */}
      {currentAnswerBlock && (
        <ToggleStage status={!!currentAnswerBlock}>
          <div ref={currentBlockRef} className="flex min-h-[calc(100vh-300px)] flex-col gap-4">
            <div className="self-end">
              <QuestionBox question={currentAnswerBlock?.question ?? ''} mode={mode} />
            </div>
            <Reasoning
              reasons={currentAnswerBlock?.reasons ?? []}
              status={currentAnswerBlock?.status ?? QuestionAnswerBlockStatus.WAITING}
            />
            {/* {currentAnswerBlock?.answers?.map((answer, index) => (
              <ComponentMapper
                key={`${answer.type}-${index}`}
                session_id={session?.id ?? ''}
                answer={answer}
                block_id={currentAnswerBlock?.id}
              />
            ))} */}
          </div>
        </ToggleStage>
      )}
    </div>
  );
}
